import { useState } from "react";
import { RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";

// "Markup: Contractor" (Admin also sees and can override the multiplier). Reprice = Draft takes the customer's current preset.
export function MarkupBar({ quoteId, markup, owner, multiplier, onOverride, onRepriced }) {
  const [busy, setBusy] = useState(false);
  const reprice = async () => {
    setBusy(true);
    try {
      onRepriced((await api.post(`/quotes/${quoteId}/reprice`)).data);
      toast.success("Repriced with the customer's markup preset");
    } catch (e) {
      toast.error(errorMessage(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div data-testid="markup-bar" className="flex flex-wrap items-center gap-3 rounded-xl border border-slate-800 px-4 py-2.5 text-sm">
      <span data-testid="markup-preset-name" className="text-slate-300">Markup: <span className="font-semibold text-slate-100">{markup.name || "Default"}</span></span>
      {owner && (
        <label className="flex items-center gap-1.5 text-xs text-slate-400">×
          <input data-testid="markup-multiplier-input" inputMode="decimal" value={multiplier ?? ""} title="Override the multiplier for this estimate"
            onChange={(e) => onOverride(e.target.value)} className="h-7 w-20 rounded border border-slate-800 bg-slate-900/70 px-2 text-right font-mono-num text-slate-100 outline-none focus:border-amber-500/70" />
        </label>
      )}
      {quoteId && markup.stage === "draft" && (
        <button data-testid="markup-reprice-button" onClick={reprice} disabled={busy}
          className="inline-flex items-center gap-1.5 rounded-full border border-slate-700 px-3 py-1 text-xs text-slate-200 transition-colors hover:border-amber-500/60 hover:text-amber-200 disabled:opacity-50">
          <RefreshCw className={`h-3.5 w-3.5 ${busy ? "animate-spin" : ""}`} /> Reprice
        </button>
      )}
    </div>
  );
}
